module.exports = __webpack_public_path__ + "img/faq_contractors.d87905aa.jpg";